//@ts-nocheck
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: 50,
  },
  pageTitle: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  title: {
    fontFamily: "rokh",
    textAlign: "right",
    fontSize: 20,
    marginTop: 10,
    fontWeight: 900,
  },
  subtitle: {
    textAlign: "right",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
  },
  section: {
    border: "1px solid #ddd",
    padding: 20,
    marginBottom: 10,
    borderRadius: 15,
    width: "100%",
  },
  testNameWrapper: {
    width: "100%",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
  },
  testNameSection: {
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  testEnName: {
    fontSize: 12,
    fontWeight: 900,
    backgroundColor: "#3498db",
    color: "white",
    padding: "5px 10px 3px 10px",
    borderRadius: 5,
    fontFamily: "rokh",
  },
  testFaName: {
    fontSize: 14,
    fontWeight: 900,
    fontFamily: "rokh",
    marginRight: 10,
    marginTop: 5,
  },
  testResult: {
    fontSize: 14,
    fontWeight: 900,
    fontFamily: "rokh",
    marginTop: 5,
  },
  description: {
    fontSize: 11,
    width: "100%",
    marginTop: 5,
    textAlign: "right",
  },
  testResultValue: {
    fontSize: 18,
    fontWeight: 900,
    fontFamily: "rokh",
    marginTop: 20,
  },
  normalSection: {
    width: "100%",
    marginTop: 5,
    textAlign: "right",
    borderTop: "1px solid #ddd",
  },
  normalSectionTitle: {
    fontSize: 14,
    fontWeight: 900,
    fontFamily: "rokh",
    marginTop: 10,
  },
  normalSectionDetail: {
    fontSize: 11,
    width: "100%",
    textAlign: "right",
  },
  detailsSection: {
    width: "100%",
    marginTop: 5,
    textAlign: "right",
    borderTop: "1px solid #ddd",
    gap: 10,
    flexDirection: "row-reverse",
    alignItems: "flex-start",
  },
  singleDetailSection: {
    width: "49%",
  },
  detailTitle: {
    fontSize: 14,
    fontWeight: 900,
    fontFamily: "rokh",
    marginTop: 10,
  },
  detailItem: {
    fontSize: 11,
    marginLeft: 10,
  },
});

const PdfFactors = ({ testResults }: any) => (
  <View style={styles.container}>
    <View style={styles.pageTitle}>
      <Text style={styles.title}>فاکتورها</Text>
      <Text style={styles.subtitle}>
        لیست تمام فاکتورهایی که توی آزمایشتون بود به همراه توضیحات مربوط بهشون
      </Text>
    </View>

    {testResults?.results?.length > 0 ? (
      testResults.results.map((dataItem, idx) => (
        <View key={idx} style={styles.section}>
          <View style={styles.testNameWrapper}>
            <View style={styles.testNameSection}>
              <Text style={styles.testEnName}>{dataItem.name}</Text>
              <Text style={styles.testFaName}>{dataItem.fa_name}</Text>
            </View>
            <Text style={styles.testResult}>
              {["ln", "n", "hn", "normal"].includes(
                dataItem.status?.toLowerCase()
              )
                ? "نرمال"
                : dataItem.status === "H"
                ? "بالا"
                : dataItem.status === "L"
                ? "پایین"
                : "غیرمعمولی"}
            </Text>
          </View>
          <Text style={styles.description}>{dataItem.description}</Text>
          <Text style={styles.testResultValue}>
            {dataItem.text_value === false
              ? "منفی"
              : dataItem.text_value === true
              ? "مثبت"
              : dataItem.text_value}
          </Text>

          {dataItem.status === "N"
            ? dataItem.normal_situation.map((normalItem, idx) => (
                <View style={styles.normalSection} key={idx}>
                  <Text style={styles.normalSectionTitle}> حالت نرمال</Text>
                  <Text key={idx} style={styles.normalSectionDetail}>
                    {normalItem}
                  </Text>
                </View>
              ))
            : dataItem.reasons_and_problems && (
                <View style={styles.detailsSection}>
                  {dataItem.reasons_and_problems
                    .filter((item) => dataItem.status === item.component_state)
                    .map((detail, index) => (
                      <View key={index} style={styles.singleDetailSection}>
                        <Text style={styles.detailTitle}>
                          {detail.type === "P" ? "عوامل" : "دلایل"}
                        </Text>
                        {detail.description.map((val, idx) => (
                          <Text key={idx} style={styles.detailItem}>
                            {val}
                          </Text>
                        ))}
                      </View>
                    ))}
                </View>
              )}
        </View>
      ))
    ) : (
      <Text style={styles.description}>داده‌ای برای نمایش وجود ندارد.</Text>
    )}
  </View>
);

export default PdfFactors;
